import React, { useEffect, useState } from "react";
import { Stack, Button } from "@mui/material";
import styles from "./Login.module.css";
import { useNavigate } from "react-router-dom";
import { signIn } from "../../Requests/AuthService";
import InputField from "../StyledComponents/InputField/InputField";


export default function Login() {

  const navigate = useNavigate()
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [isDisabledButton, setIsDisabledButton] = useState(true)

  useEffect(() => {
    const isDisabled = (email.length === 0 || password.length === 0)
    setIsDisabledButton(isDisabled)
  }, [email, password])

  const logIn = async function () {
    try {
      await signIn(email, password)
      setEmail('')
      setPassword('')
      navigate("/")
    } catch (error) {
      alert(error.message)
    }
  }

  return (
    <div className={styles.container}>
      < Stack
        component="form"
        sx={{ width: '40ch' }}
        spacing={2}
        noValidate
        autoComplete="off"
      >
        <InputField
          label="Email"
          type="email"
          onChange={(event) => setEmail(event.target.value)}
        />

        <InputField
          label="Password"
          type="password"
          onChange={(event) => setPassword(event.target.value)}
        />

        <Button variant="contained" disabled={isDisabledButton} onClick={() => { logIn() }}>Login</Button>
      </Stack>
    </div>
  )
}
